import Button from 'components/button';
import { ReactNode, useMemo } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  min-height: 50px;
  margin-bottom: 13px;
  /* Match the chart controls row (SlideButtonsGroup) padding so the export
     button's right edge aligns with the chart grid below it. */
  padding-right: 30px;
`;

const PanelLabel = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

// Right-aligned cluster grouping the metric tabs with the chart export button,
// matching the Figma header row (10px gap, vertically centered).
const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  button {
    height: 24px;
    text-transform: uppercase;
  }
`;

const ActionButtonContainer = styled.div`
  width: 150px;
`;

interface FCProps {
  dataDisplay: { key: string; checked?: boolean; text: string; label: string }[];
  togglePanelOption: (key: string) => void;
  actionButton?: string;
  onClickactionButton?: () => void;
  /** Rendered on the right of the header row, after the metric tabs (e.g. export button). */
  rightSlot?: ReactNode;
}

const PanelHeader = ({
  togglePanelOption,
  dataDisplay,
  actionButton,
  onClickactionButton,
  rightSlot,
}: FCProps): JSX.Element => {
  const label = useMemo(() => {
    const option = dataDisplay.find((item) => item.checked);
    return option?.text;
  }, [dataDisplay]);

  const hasPanelOptions = useMemo(() => {
    return dataDisplay.length > 1;
  }, [dataDisplay]);

  const btnStyles = {
    fontSize: '12px',
    padding: '5px 10px',
    height: '24px',
    lineHeight: '14px',
    borderRadius: '10px',
  } as React.CSSProperties;

  return (
    <Container>
      <PanelLabel dangerouslySetInnerHTML={{ __html: label }}></PanelLabel>
      {actionButton && (
        <ActionButtonContainer>
          <Button $secondary onClick={onClickactionButton} size="small" $full>
            {actionButton}
          </Button>
        </ActionButtonContainer>
      )}
      {(hasPanelOptions || rightSlot) && (
        <RightControls>
          {hasPanelOptions && (
            <ButtonsContainer>
              {dataDisplay.map(({ key, label, checked }) => {
                return (
                  <Button
                    key={`type-${key}`}
                    $primary={checked}
                    $terciary={!checked}
                    size="small"
                    style={{ ...btnStyles, fontWeight: `${checked ? '700' : '500'}` }}
                    onClick={() => {
                      togglePanelOption(key);
                    }}
                  >
                    {label}
                  </Button>
                );
              })}
            </ButtonsContainer>
          )}
          {rightSlot}
        </RightControls>
      )}
    </Container>
  );
};
export default PanelHeader;
